import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Flame, X, ArrowRight } from "lucide-react";
import { readStreak } from "../lib/streak";

const DISMISS_KEY = "cv_streak_reminder_dismissed";

export const StreakReminder = () => {
  const today = new Date().toISOString().slice(0, 10);
  const [streak] = useState(readStreak);
  const [hidden, setHidden] = useState(() => localStorage.getItem(DISMISS_KEY) === today);
  if (hidden || !streak.count || streak.playedToday) return null;

  const dismiss = () => { localStorage.setItem(DISMISS_KEY, today); setHidden(true); };
  return (
    <div data-testid="streak-reminder" className="bg-[#2D4A3E] text-white cv-fade-up">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-2.5 flex items-center gap-3">
        <span className="w-7 h-7 shrink-0 rounded-full bg-[#E5EEE8] text-[#2D4A3E] flex items-center justify-center"><Flame className="w-3.5 h-3.5" /></span>
        <p className="font-ui text-sm flex-1 min-w-0">
          <span className="font-semibold">Keep your {streak.count}-day streak.</span>
          <span className="text-white/75 hidden sm:inline"> Today's Daily Three is waiting, just three questions.</span>
        </p>
        <Link to="/trivia/play?mode=mc&group=0&source=daily" data-testid="streak-reminder-play"
          className="shrink-0 inline-flex items-center gap-1 bg-white text-[#161514] rounded-full px-3.5 py-1.5 font-ui text-xs font-semibold hover:bg-[#F4F1EA] active:scale-[0.98] transition-[transform,background-color]">
          Play now <ArrowRight className="w-3.5 h-3.5" />
        </Link>
        <button onClick={dismiss} data-testid="streak-reminder-dismiss" aria-label="Dismiss streak reminder" className="shrink-0 p-1 text-white/60 hover:text-white transition-colors">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};
